// Cross-app deep-link targets. The marketing site (doccareplus.com) sends
// visitors to the product apps on their own subdomains. Overridable per
// environment via VITE_CLINIC_URL / VITE_PORTAL_URL.
export const CLINIC_URL = import.meta.env.VITE_CLINIC_URL ?? 'https://clinic.doccareplus.com';
export const PORTAL_URL = import.meta.env.VITE_PORTAL_URL ?? 'https://patients.doccareplus.com';
